/* eslint-disable no-confusing-arrow */
import React, { useMemo } from 'react';
import { ProductDetailsProps } from '@customTypes/product-details';
import useHotSpot from '@hooks/useHotSpot';
import ProductDetailsPriceWithSTP from './ProductDetailsPriceWithSTP';
import ProductTagFactoryWithSTP from './ProductTagFactoryWithSTP';

type DiscountPriceProps = {
  personType: 'adult' | 'child';
  isTimeSlotted?: boolean;
  hideDiscountPrice?: boolean;
  individualBilling?: boolean;
} & Omit<ProductDetailsProps, 'setCartData' | 'setIsDrawerOpen'>;

export default function DiscountPriceWithSTP({
  cartData,
  date,
  hotelDetails,
  product,
  showFairPricing,
  personType,
  isTimeSlotted,
  hideDiscountPrice,
  individualBilling,
}: DiscountPriceProps) {
  const { getTheTimeWithTheLowestPrice } = useHotSpot();

  const containerStyles = useMemo(
    () =>
      isTimeSlotted && !individualBilling && !hideDiscountPrice
        ? 'flex-col-reverse items-end'
        : 'items-center',
    [individualBilling, isTimeSlotted, hideDiscountPrice],
  );

  return (
    <div className={`flex ${containerStyles} gap-2`}>
      {!hideDiscountPrice && (
        <ProductDetailsPriceWithSTP
          cartData={cartData}
          date={date}
          hotelDetails={hotelDetails}
          personType={personType}
          timeSlotDesign={isTimeSlotted}
          individualBilling={individualBilling}
          product={
            product && product.is_product_time_group && product.children && !individualBilling
              ? getTheTimeWithTheLowestPrice(product.children, hotelDetails, cartData)
              : product
          }
          showFairPricing={showFairPricing}
        />
      )}
      <div>
        <ProductTagFactoryWithSTP
          date={date}
          cartData={cartData}
          hotelDetails={hotelDetails}
          product={product}
          individualBilling={individualBilling}
          hideDiscountPrice={hideDiscountPrice}
          personType={personType}
        />
      </div>
    </div>
  );
}

DiscountPriceWithSTP.defaultProps = {
  isTimeSlotted: false,
  hideDiscountPrice: false,
  individualBilling: false,
};
